var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c(
        "div",
        [
          _c("el-row", [
            _vm.bytes
              ? _c(
                  "div",
                  { attrs: { id: "pdf" } },
                  [_c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })],
                  1
                )
              : _vm._e()
          ]),
          _c("el-row", [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.radiosAcoes.length
                  ? _c("app-radios-tramitacao", {
                      attrs: {
                        radios: _vm.radiosAcoes,
                        isDecisao: true,
                        radioInicial: _vm.radioInicial
                      },
                      on: { changeRadio: _vm.changeRadio }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("el-row", [
            _c(
              "div",
              { attrs: { id: "btn" } },
              [
                _c("app-buttons-cadastro", {
                  attrs: {
                    showButtonDownload: true,
                    showButtonCancelar: false,
                    isUltimoPasso: true,
                    finalizarLabel: "Finalizar",
                    downloadLabel: "Download PDF"
                  },
                  on: {
                    download: _vm.download,
                    voltar: _vm.goToListagem,
                    finalizar: _vm.finalizar
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4a9fc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4a9fc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gp/components/diarioOficial/EncaminharPublicacao.vue
// module id = null
// module chunks = 